import { Injectable, inject } from '@angular/core'
import { WeightType } from '@tradecafe/types/core'
import { pick } from 'lodash-es'
import { AuthApiService } from 'src/api/auth'
import { WeightTypeApiService } from 'src/api/product/weight-type'

const ALLOWED_FIELDS = ['name']
const CACHE_MAX_AGE = 3600 * 1000 // 1hr

@Injectable()
export class WeightTypesService {
  private AuthApi = inject(AuthApiService)
  private WeightTypeApi = inject(WeightTypeApiService)


  private cacheExpiration = 0
  private cache = Promise.resolve({ data: [] })

  /**
   * Get all available weightTypes
   *
   * @param {any} query
   * @returns {Object} { total_rows:number, data: []}
   */
  async getWeightTypes() {
    if (!this.cache || this.cacheExpiration < Date.now()) {
      this.cacheExpiration = Date.now() + CACHE_MAX_AGE // 1 min
      // NOTE: we fetch everything
      this.cache = this.WeightTypeApi.list({ limit: Number.MAX_SAFE_INTEGER })
      .catch((err) => {
        this.invalidateCache()
        throw err
      })
    }
    const { data } = await this.cache
    return data
  }

  /**
   * Create new weightType
   *
   * @param {any} weightType
   * @returns
   */
  async create(weightType: Partial<WeightType>) {
    const payload = pick(weightType, ALLOWED_FIELDS)
    const { user_id } = this.AuthApi.currentUser
    payload.user_id = user_id

    const { data } = await this.WeightTypeApi.create(payload)
    this.invalidateCache()
    return data
  }

  /**
   * Update weightType
   *
   * @param {any} weightType
   * @returns
   */
  async update(weightType: Partial<WeightType>) {
    const { type_id } = weightType
    const payload = pick(weightType, ALLOWED_FIELDS)
    const { user_id } = this.AuthApi.currentUser
    payload.user_id = user_id

    const { data } = await this.WeightTypeApi.update(type_id, payload)
    this.invalidateCache()
    return data
  }

  /**
   * Update weightType
   *
   * @param {any} weightType
   * @returns
   */
  async remove(type_id: string) {
    const { data } = await this.WeightTypeApi.delete(type_id)
    this.invalidateCache()
    return data
  }


  /**
   * Invalidate weightTypes in-memory cache
   *
   * @private
   */
  private invalidateCache() {
    this.cacheExpiration = 0
  }
}
